import { Link, LinkProps } from "react-router-dom";
import { usePropsToWithUTM } from "../../helpers/usePropsToWithUTM";

export function LinkKeepUTM(props: LinkProps) {
  return <Link {...usePropsToWithUTM(props)} />;
}
